import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';

export const SelectGroupDefaultProps = {
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  context: null,
  label: null,
  onChange: () => {},
  options: {
    categories: [],
    orphan_wishlists: [],
    wishlist_full_count: 0,
  },
  placeholder: '',
  readOnly: false,
  required: false,
  type: null,
  value: null,
};

export const SelectGroupPropTypes = {
  ...ClassNamePropTypes,
  ...DisabledPropTypes,
  context: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.shape({
    // TODO: to refactor > to array
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(PropTypes.shape({})),
        wishlists: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
    orphan_wishlists: PropTypes.arrayOf(
      PropTypes.shape({
        item_count: PropTypes.number,
      }),
    ),
    wishlist_full_count: PropTypes.number,
  }),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
};
